export const getLabelFromUrl = (url, runtimeConfig) => {
  if (!url) {
    console.error('URL parameter is required')
    return null
  }

  // Validate runtime config
  if (!runtimeConfig.HOSTNAME_SITES) {
    console.error('HOSTNAME_SITES not found in public runtime config')
    return null
  }
  if (!runtimeConfig.LABELID_SITES) {
    console.error('LABELID_SITES not found in public runtime config')
    return null
  }

  const sites = runtimeConfig.HOSTNAME_SITES.split(',').map(site => site.trim())
  const sitesId = runtimeConfig.LABELID_SITES.split(',').map(id => id.trim())

  // Validate arrays have same length
  if (sites.length !== sitesId.length) {
    console.error('HOSTNAME_SITES and LABELID_SITES arrays must have same length')
    return null
  }

  // Extract hostname from URL
  let hostname
  try {
    hostname = new URL(url).hostname
  } catch (error) {
    // If URL parsing fails, assume it's already a hostname
    hostname = url
  }

  // Find matching site
  const index = sites.findIndex(site => site === hostname)

  if (index !== -1) {
    return sitesId[index]
  }

  // No match found
  console.warn(`No label found for hostname: ${hostname}`)
  return null
}


export const getUrl = (language, label, hostname, runtimeConfig, apiHostURL,isIntranet) => {
 
  if (isIntranet){
    const { useIntranetLogin } = useIntranetAuth()
    if(useIntranetLogin()){
       return `${apiHostURL}/api/${label}/siteJSON/${language}`  
    }
  }
  if (runtimeConfig.USE_LOCAL_JSON == 1) {
    // Load the JSON's locally from the static map, so no communication needed with an external server
    return `${runtimeConfig.SERVER_HOST_PROTOCOL}://${runtimeConfig.SERVER_HOST}:${runtimeConfig.NITRO_PORT}/${language}.json`;
  } 
  if (runtimeConfig.JSON_FROM_CACHE == 1) {
    // intranet always load json via api, so actuel login data is present
    return `${runtimeConfig.SERVER_HOST_PROTOCOL}://${hostname}/cache/JSON/${label}_${language.toUpperCase()}.json`;
  } 
  
  return `${apiHostURL}/api/${label}/generateJSON/${language}`
}
export const getSitemapUrl = (label,apiHostURL, language) => {
  return `${apiHostURL}/api/${label}/sitemap/${language}`
}
export const getHeaders = () => {
  const authIntranet = useAuthIntranetStore();
  const { isIntranet } = useIntranetAuth()
  const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  };

  // add bearer token with intranet
  const token = authIntranet.getToken;
  if (isIntranet() && token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return headers;
};

export const getLanguageObjectsURL = (fullPath, labelId) => {
      
      const runtimeConfig = useRuntimeConfig();
       let localesUse = [
        {code:'en',},
        {code:'nl'},
        {code:'befr'},
        {code:'benl'},
        {code:'de'},
        {code:'fr'},
      ]

      let defaultLanguage = 'nl'
      if (runtimeConfig.SITES_DEFAULT_LANGUAGES) {
        let SITES_DEFAULT_LANGUAGES_ARR = runtimeConfig.SITES_DEFAULT_LANGUAGES.split(",");
        for (let index = 0; index < SITES_DEFAULT_LANGUAGES_ARR.length; ++index) {
          let siteDefObj = SITES_DEFAULT_LANGUAGES_ARR[index].split(":")
          if (siteDefObj[0] == labelId) {
            defaultLanguage = siteDefObj[1]
          }
        }
      }

      const parts = fullPath.split("/")
      let languagePart = defaultLanguage;
      if (parts[1]) {
        languagePart = localesUse.filter((i) => i.code == parts[1]).length > 0 ? parts[1] : defaultLanguage
      }
      return [languagePart, localesUse, defaultLanguage]
}
